import React, { useState } from 'react';
import { steps } from './Register.utils';
import { RegisterDataProps } from './Register.types';

const Register: React.FC = () => {
  const [currentStepIdx, setCurrentStepIdx] = useState<number>(1);
  const [registerData, setRegisterData] = useState<RegisterDataProps>({});

  const moveToNextStep = (props?: Partial<RegisterDataProps>) => {
    setRegisterData((currentData) => ({
      ...currentData,
      ...props,
    }));
    setCurrentStepIdx((idx) => Math.min(idx + 1, steps.length));
  };

  const moveToPrevStep = () => {
    setCurrentStepIdx((idx) => Math.max(idx - 1, 1));
  };

  return (
    <>
      {steps.map(
        ({ stepId, Component }) =>
          currentStepIdx === stepId && (
            <Component
              key={stepId}
              onGoNext={moveToNextStep}
              onGoPrev={moveToPrevStep}
              stepIndex={currentStepIdx}
              stepsLength={steps.length - 1} // minus success screen
              phoneNumber={registerData.formattedPhoneNumber}
            />
          )
      )}
    </>
  );
};

export default Register;
